import { useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import Dialog from '../../organisms/Dialog';
import InventoryForm from './shared/InventoryForm';
import useInventoryPageForm from '../../../hooks/useInventoryPageForm';

interface InventoryListContext {
    refresh: () => void;
}

const InventoryAssetPageForm = () => {
    const navigate = useNavigate();
    const context = useOutletContext<InventoryListContext>();

    const handleClose = () => navigate('/collateral/inventories');

    const handleSuccess = () => {
        toast.success('Estoque cadastrado com sucesso');
        context?.refresh();
        handleClose();
    };

    const form = useInventoryPageForm({ onClose: handleClose, onCreated: handleSuccess });

    return (
        <Dialog
            id="inventory-asset-form"
            show={true}
            onClose={handleClose}
            header="Novo Estoque"
            size="lg"
            body={<InventoryForm {...form} />}
            footer={
                <div className="flex gap-2">
                    <button onClick={handleClose} disabled={form.isCreating}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 text-sm disabled:opacity-50">
                        Cancelar
                    </button>
                    <button onClick={form.handleCreate} disabled={form.isCreating}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm disabled:opacity-50">
                        {form.isCreating ? 'Salvando...' : 'Cadastrar'}
                    </button>
                </div>
            }
        />
    );
};

export default InventoryAssetPageForm;
